import { getCategoryUrl } from '@msdyn365-commerce-modules/retail-actions';
import { format } from '@msdyn365-commerce-modules/utilities';
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import { IComponent, IComponentProps, IGridSettings, IImageData, IImageSettings, Image } from '@msdyn365-commerce/core';
import React from 'react';

export interface ICategoryComponentProps extends IComponentProps<{ category?: CategoryHierarchy }> {
    className?: string;
    imageSettings?: IImageSettings;
    page?: string;
}

export interface ICategoryComponent extends IComponent<ICategoryComponentProps> {}

const Category: React.FC<ICategoryComponentProps> = ({ data, context, imageSettings, typeName, id, page }) => {
    const category = data.category;
    if (!category) {
        return null;
    }
    const apiSettings = context && context.request ? context.request.apiSettings : undefined;
    const categoryUrl = getCategoryUrl(category, context.actionContext);
    const categoryId = categoryUrl && _getCategoryIdFromUrl(categoryUrl);
    const sitePath = context.request.sitePath ? context.request.sitePath : '';
    const regionUrl = `${context.request.url.requestUrl.origin}${sitePath}/category-listing/?categoryId=${categoryId}`;
    const categoryImageUrl = category && category.RecordId ? `Categories/category_${category.RecordId}.png` : '';
    const imageUrlFullPath = apiSettings && apiSettings.baseImageUrl && categoryImageUrl ? apiSettings.baseImageUrl + categoryImageUrl : '';
    return (
        <a
            href={page === 'categories' ? `${context.request.url.requestUrl.origin}/${categoryUrl}` : regionUrl}
            aria-label={renderLabel(category.Name)}
            className='msc-product'
        >
            {page && page === 'categories' && (
                <div className='msc-product__image'>
                    {renderCategoryPlacementImage(
                        imageSettings,
                        context.request.gridSettings,
                        imageUrlFullPath || undefined,
                        category.Name
                    )}
                </div>
            )}
            <div className='msc-product__details'>
                <h4 className='msc-product__title'>{category.Name}</h4>
            </div>
        </a>
    );
};

function _getCategoryIdFromUrl(url: string): string | null {
    if (!url) {
        return null;
    }

    const splitPath = url.split('/');
    const categoryPath = splitPath[splitPath.length - 1];
    const categoryPathSplitted = categoryPath.split('?');
    const formattedCatId = categoryPathSplitted[0].substring(0, categoryPathSplitted[0].length - 2);
    if (categoryPathSplitted.length > 1) {
        return `${formattedCatId}&${categoryPathSplitted[1]}`;
    } else {
        return formattedCatId;
    }
}

function renderLabel(name?: string, price?: string, rating?: number, ratingAriaLabel?: string): string {
    let ratingLabel = '';

    name = name || '';
    price = price || '';

    if (rating) {
        const roundedRating = rating.toFixed(2);
        ratingLabel = format(ratingAriaLabel || '', roundedRating, '5');
    }

    return `${name} ${price} ${ratingLabel}`;
}

const renderCategoryPlacementImage = (
    imageSettings?: IImageSettings,
    gridSettings?: IGridSettings,
    imageUrl?: string,
    altText?: string
): JSX.Element | null => {
    if (!imageUrl || !gridSettings) {
        return null;
    }

    const img: IImageData = {
        src: imageUrl,
        altText: altText ? altText : ''
    };
    const imageProps = {
        gridSettings: gridSettings,
        imageSettings: imageSettings
    };
    return <Image {...img} {...imageProps} loadFailureBehavior='empty' />;
};

export default Category;
